import { render, staticRenderFns } from "./SelectCMS.vue?vue&type=template&id=bb3803bc&"
import script from "./SelectCMS.vue?vue&type=script&lang=ts&"
export * from "./SelectCMS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports